module.exports = __webpack_public_path__ + "img/banner-pc.b1829fb8.png";